<template>
  <div>
    <!-- update processor modal -->
    <div
      class="modal fade" 
      id="modal-feedback-update-processor-action"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click="onCloseProcessorModal()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("feedback.updateProcessor") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("feedback.processor") }}</label>
                  <v-select
                    class="clear"
                    :options="departmentList"
                    :reduce="data => data.id"
                    :getOptionLabel="option => $t(option.name)"
                    v-model="departmentSelectId"
                    :placeholder="$t('feedback.processor')"
                  >
                    <template v-slot:option="option">
                      {{ option.name }}
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("common.comment") }}</label>
                  <textarea
                    class="form-control"
                    name=""
                    id=""
                    cols="30"
                    rows="4"
                    v-model="updateDepartmentComment"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right"
              @click="onUpdateFeedbackProcessor()"
            >
              {{ $t("common.confirm") }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="onCloseProcessorModal()"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- update assigner modal -->
    <div 
      class="modal fade" 
      id="modal-feedback-update-assigner-action"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="onCloseAssginerModal()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("feedback.updatePersonHandle") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("feedback.processor") }}</label>
                  <v-select
                    class="clear"
                    :options="staffs"
                    v-model="assignerIdSelectId"
                    :reduce="data => data.value"
                    :getOptionLabel="option => $t(option.full_name)"
                    :filter="onSearchUserVueSelect"
                    :placeholder="$t('case.assignto')"
                  >
                    <template #list-header>
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">
                              {{ $t("customer.fullname") }}
                            </th>
                            <th scope="col">{{ $t("customer.email") }}</th>
                          </tr>
                        </thead>
                      </table>
                    </template>
                    <template v-slot:option="option">
                      <div
                        style="display: flex; padding-top: 5px; padding-bottom: 5px; border-bottom: 1px solid #ccc"
                      >
                        <div style="width: 50%; word-break: break-all;">
                          {{ $t(option.full_name) }}
                        </div>
                        <div style="width: 50%">
                          {{ $t(option.email) }}
                        </div>
                      </div>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("common.comment") }}</label>
                  <textarea
                    class="form-control"
                    name=""
                    id=""
                    cols="30"
                    rows="4"
                    v-model="updateAssignerComment"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right"
              @click="onUpdateFeedbackAssigner()"
            >
              {{ $t("common.confirm") }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="onCloseAssginerModal()"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import Loading from "vue-loading-overlay";

export default {
  components: {
    loading: Loading,
  },
  data: () => ({
    feedbackId: null,
    // processcor
    departmentList: [],
    departmentSelectId: null,
    updateDepartmentComment: null,
    // assigner
    staffs: [],
    assignerIdSelectId: [],
    updateAssignerComment: null,
    isLoading: false
  }),
  watch: {},
  computed: {
    ...mapGetters([])
  },
  methods: {
    // processor
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    onCloseProcessorModal: function() {
      $("#modal-feedback-update-processor-action").modal("hide");
    },
    onShowProcessorModal: function() {
      $("#modal-feedback-update-processor-action").modal("show");
    },
    onShowUpdateFeedbackProcessor: function(feedbackId, departmentId) {
      this.onShowProcessorModal();
      this.getDepartmentList();
      this.feedbackId = feedbackId;
      this.departmentSelectId = departmentId;
      this.updateDepartmentComment = null;
    },
    onUpdateFeedbackProcessor: function() {
      this.isLoading = true
      let data = {
        feedbackId: this.feedbackId,
        departmentId: this.departmentSelectId,
        comment: utils.getCleanStringValue(this.updateDepartmentComment),
        isProcessor: true
      };
      this.UPDATE_ASSIGNER_AND_PROCESSOR_FEEDBACK(data).then(
        function() {
          this.isLoading = false;
          this.onCloseProcessorModal();
          this.$emit("updateAssignerAndProcessor", true);
          this.SUCCESS_TOAST();
        }.bind(this)
      ).catch(
        function(error) {
          let mess = error.response.data.message;
          this.showError(mess);
          this.isLoading = false;
        }.bind(this)
      );
    },
    getDepartmentList: function() {
      this.GET_DEPARTMENT_LIST().then(
        function(res) {
          let data = res;
          this.departmentList = [];
          data.forEach(value => {
            let item = {
              id: value.id,
              name: value.name
            };
            this.departmentList.push(item);
          });
        }.bind(this)
      );
    },
    // assigner
    onCloseAssginerModal: function() {
      $("#modal-feedback-update-assigner-action").modal("hide");
    },
    onShowAssignerModal: function() {
      $("#modal-feedback-update-assigner-action").modal("show");
    },
    onShowUpdateFeedbackAssigner: function(feedbackId, assignerId) {
      this.onShowAssignerModal();
      this.getStaffList();
      this.feedbackId = feedbackId;
      this.assignerIdSelectId = assignerId;
      this.updateAssignerComment = null;
    },
    onUpdateFeedbackAssigner: function() {
      let data = {
        feedbackId: this.feedbackId,
        assignerId: this.assignerIdSelectId,
        comment: utils.getCleanStringValue(this.updateAssignerComment),
        isAssigner: true
      };
      this.UPDATE_ASSIGNER_AND_PROCESSOR_FEEDBACK(data).then(
        function() {
          this.isLoading = false;
          this.onCloseAssginerModal();
          this.$emit("updateAssignerAndProcessor", true);
          this.SUCCESS_TOAST();
        }.bind(this)
      ).catch(
        function(error) {
          let mess = error.response.data.message;
          this.showError(mess);
          this.isLoading = false;
        }.bind(this)
      );
    },
    getStaffList: function() {
      let filter = {
        params: {
          feedbackId: this.feedbackId
        }
      }
      this.GET_STAFF_LIST(filter).then(
        function(res) {
          let staffList = res.data;
          let staffs = [];
          staffList.forEach(data => {
            let full_name = `${data.last_name} ${data.first_name}`;
            let item = {
              value: data.id,
              full_name: full_name,
              email: data.email
            };
            staffs.push(item);
          });
          this.staffs = staffs;
        }.bind(this)
      );
    },
    onSearchUserVueSelect: function(options, search) {
      let resultSearch = options.filter(
        x =>
          x.full_name.toLowerCase().includes(search.toLowerCase()) ||
          x.email.toLowerCase().includes(search.toLowerCase())
      );
      return search.length > 0 && resultSearch.length > 0 ? resultSearch : [];
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "GET_DEPARTMENT_LIST",
      "GET_STAFF_LIST",
      "UPDATE_ASSIGNER_AND_PROCESSOR_FEEDBACK"
    ])
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Case/FeedbackUpdateAssignerAndProcessorModal.vue